import { render, staticRenderFns } from "./NewDocument.vue?vue&type=template&id=6cb85722&scoped=true&"
import script from "./NewDocument.vue?vue&type=script&lang=js&"
export * from "./NewDocument.vue?vue&type=script&lang=js&"
import style0 from "./NewDocument.vue?vue&type=style&index=0&id=6cb85722&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb85722",
  null
  
)

export default component.exports